import { render } from "./prospectus-count.vue?vue&type=template&id=f42d71be&scoped=true"
import script from "./prospectus-count.vue?vue&type=script&lang=js"
export * from "./prospectus-count.vue?vue&type=script&lang=js"

import "./prospectus-count.vue?vue&type=style&index=0&id=f42d71be&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f42d71be"]])

export default __exports__